export default __webpack_public_path__ + "static/media/h_2.b5ac85f3.jpg";